// extracted by mini-css-extract-plugin
export var link = "search-content-module--link--80m-z";
export var resultWrapper = "search-content-module--result-wrapper--DC0Yi";
export var searchContent = "search-content-module--search-content--51F7w";